import React, { Component } from "react";
import {
  CardBody,
  Card,
} from "reactstrap";
import axios from "axios";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";
import {
  SetItemsSelected,
  NotificatioErrController,
  NotificatioSucController,
  ToTitleCaseName,
} from "../../../helpers/Utils";
import createSocket from "../../../helpers/createSocket";
import {
  ContentFormAddExcel,
  CustomerModernDashboard,
} from "../../../containers/pages/customer";
import { Add } from "../../../containers/pages/general";
import LogsHelper from "../../../helpers/Logs";
import IntlMessages from "../../../helpers/IntlMessages";
import { isC, isR, isU, isD } from "../../../helpers/Roles";
import FooterPage from "../../../containers/pages/FooterPage";
import FooterCustomer from "../../../containers/pages/customer/FooterCustomer";
import AddCustomer from "../../../containers/pages/customer/AddCustomer";
import UpdateCustomer from "../../../containers/pages/customer/UpdateCustomer";
import { connect } from "react-redux";
import { setSearchContext } from "../../../redux/actions";
import moment from "moment";

const DEFAULT_FORM = {
  id: "",
  name: "",
  phone: "",
  email: "",
  address: "",
  point: "",
  armorial: "",
  used: 0,
  debt: "",
  debt_more: "",
  debt_less: "",
  debt_limit: "",
  tags: "",
  dynamic_form: [],
};

const ROLE_ALIAS = "customer";

class ContentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: {
        pageSizes: [12, 24],
        selectedPageSize: 12,
        currentPage: 1,
        totalPage: 1,
        totalItem: 0,
        search: "",
      },
      filters: {
        date_start: "",
        date_end: "",
        all: true,
        preset: "all",
      },
      selectedItems: [],
      data: [],
      data_all: [],
      data_length: 0,

      data_customer: null,
      filter: null,
      dashboard_summary: null,
      customer_activity: [],
      customer_products: [],
      is_loading_activity: false,
      is_loading_products: false,
      activeCustomerId: "",

      data_dynamic_form: [],
      is_loading_data: true,
      data_tags: [],
      show: {
        add: false,
        add_excel: false,
        update: false,
        view: false,
        viewonly: false,
      },

      accordion: [],
      activeTab: "1",
      license: {},

      displayMode: "thumblist",

      form: DEFAULT_FORM,
      changedCustomers: {},
    };

    this.socket = createSocket();
  }

  componentDidMount() {
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    // Set search context cho Navbar
    this.props.setSearchContext("customer");

    this.dataListTagsRender();
    this.dataAllRender();
    this.dataDashboardSummaryRender();

    window.addEventListener("refresh-customer-list", this.handleRefreshEvent);
  }

  componentWillUnmount() {
    window.removeEventListener("refresh-customer-list", this.handleRefreshEvent);
  }

  handleRefreshEvent = () => {
    this.dataListTagsRender();
    this.dataAllRender();
    this.dataDashboardSummaryRender();
  };

  emitOrderRefresh = () => {
    const user_id = localStorage.getItem("user_id");
    this.socket.emit("refresh-done-order", { user_id });
    this.socket.emit("refresh-recent-order", { user_id });
  };

  getCustomerForm = (item = {}) => ({
    id: item.id || "",
    name: item.name ? item.name : "",
    phone: item.phone || "",
    email: item.email ? item.email : "",
    address: item.address ? item.address : "",
    point: item.point || 0,
    armorial: item.armorial || "",
    used: item.used || 0,
    debt: item.debt || "",
    debt_more: "",
    debt_less: "",
    debt_limit: item.debt_limit || "",
    tags: item.tags || [],
    dynamic_form: item.dynamic_form || {},
  });

  selectActiveCustomer = (item) => {
    if (!item || !item.id) {
      this.setState((prev) => ({
        ...prev,
        activeCustomerId: "",
        customer_activity: [],
        customer_products: [],
        is_loading_products: false,
        form: DEFAULT_FORM,
      }));
      return;
    }

    this.setState(
      (prev) => ({
        ...prev,
        activeCustomerId: item.id,
        customer_products:
          item.id === prev.activeCustomerId ? prev.customer_products : [],
        is_loading_products:
          item.id === prev.activeCustomerId ? prev.is_loading_products : false,
        show: {
          ...prev.show,
          view: true,
          viewonly: false,
        },
        form: this.getCustomerForm(item),
      }),
        () => {
          this.dataCustomerActivityRender(item.id);
          this.dataCustomerProductsRender(item.id);
        },
    );
  };

  componentDidUpdate(prevProps) {
    // Listen thay đổi searchKeyword từ Redux (Navbar search)
    if (prevProps.searchKeyword !== this.props.searchKeyword) {
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: this.props.searchKeyword,
          },
        }),
        () => this.dataListRender(),
      );
    }
  }

  getDateQueryString = (prefix = "&") => {
    const { filters } = this.state;
    if (filters.all || !filters.date_start) return "";
    let start = filters.date_start;
    let end = filters.date_end || filters.date_start;
    if (start > end) {
      [start, end] = [end, start];
    }
    return `${prefix}date_start=${start}&date_end=${end}`;
  };

  getDatePresetRange = (preset) => {
    const today = moment().format("YYYY-MM-DD");
    if (preset === "today") {
      return { date_start: today, date_end: today };
    }
    if (preset === "yesterday") {
      const yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
      return { date_start: yesterday, date_end: yesterday };
    }
    if (preset === "week") {
      return {
        date_start: moment().startOf("isoWeek").format("YYYY-MM-DD"),
        date_end: moment().endOf("isoWeek").format("YYYY-MM-DD"),
      };
    }
    if (preset === "last_week") {
      return {
        date_start: moment().subtract(1, "week").startOf("isoWeek").format("YYYY-MM-DD"),
        date_end: moment().subtract(1, "week").endOf("isoWeek").format("YYYY-MM-DD"),
      };
    }
    if (preset === "month") {
      return {
        date_start: moment().startOf("month").format("YYYY-MM-DD"),
        date_end: moment().endOf("month").format("YYYY-MM-DD"),
      };
    }
    if (preset === "last_month") {
      return {
        date_start: moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
        date_end: moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
      };
    }
    return null;
  };

  setDatePreset = (preset) => {
    if (preset === "all") {
      this.setState(
        (prev) => ({
          ...prev,
          filter: null,
          filters: {
            date_start: "",
            date_end: "",
            all: true,
            preset: "all",
          },
          page: {
            ...prev.page,
            currentPage: 1,
          },
        }),
        () => {
          this.dataListRender();
          this.dataAllRender();
          this.dataDashboardSummaryRender();
          if (this.state.activeCustomerId) {
            this.dataCustomerActivityRender(this.state.activeCustomerId);
            this.dataCustomerProductsRender(this.state.activeCustomerId);
          }
        },
      );
      return;
    }

    const range = this.getDatePresetRange(preset);
    if (range) {
      this.setState(
        (prev) => ({
          ...prev,
          filter: null,
          filters: {
            ...range,
            all: false,
            preset,
          },
          page: {
            ...prev.page,
            currentPage: 1,
          },
        }),
        () => {
          this.dataListRender();
          this.dataAllRender();
          this.dataDashboardSummaryRender();
          if (this.state.activeCustomerId) {
            this.dataCustomerActivityRender(this.state.activeCustomerId);
            this.dataCustomerProductsRender(this.state.activeCustomerId);
          }
        },
      );
    }
  };

  onDateRangeChange = (range, interaction = {}) => {
    let dateStart = moment(range.startDate).format("YYYY-MM-DD");
    let dateEnd = moment(range.endDate).format("YYYY-MM-DD");

    if (dateStart > dateEnd) {
      [dateStart, dateEnd] = [dateEnd, dateStart];
    }

    if (dateStart === "1900-01-01" && dateEnd === "1900-01-01") {
      this.setDatePreset("all");
      return;
    }

    this.setState(
      (prev) => ({
        ...prev,
        filter: null,
        filters: {
          date_start: dateStart,
          date_end: dateEnd,
          all: false,
          preset: "custom",
        },
        page: {
          ...prev.page,
          currentPage: 1,
        },
      }),
      () => {
        this.dataListRender();
        this.dataAllRender();
        this.dataDashboardSummaryRender();
        if (this.state.activeCustomerId) {
          this.dataCustomerActivityRender(this.state.activeCustomerId);
          this.dataCustomerProductsRender(this.state.activeCustomerId);
        }
      },
    );
  };

  onClearDateFilter = () => {
    this.setDatePreset("all");
  };

  /** Axios func helper */
  dataListRender = () => {
    const { selectedPageSize, currentPage, search } = this.state.page;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(
        `${
          END_POINT + "/customer/json"
        }?pageSize=${selectedPageSize}&currentPage=${currentPage}&search=${search}${this.getDateQueryString("&")}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((data) => {
        let anyAccordion = [];
        let numeroPerguntas = data.data.length;
        for (var i = 0; i < numeroPerguntas; i++) {
          // if (!i) {
          //     anyAccordion.push(true);
          // }
          anyAccordion.push(false);
        }
        const nextActiveCustomer =
          data.data.find((item) => item.id === this.state.activeCustomerId) ||
          data.data[0] ||
          null;

        this.setState(
          (prev) => ({
            ...prev,
            data: data.data,
            data_dynamic_form: data.dataDynamicForm,
            is_loading_data: false,
            activeCustomerId: nextActiveCustomer ? nextActiveCustomer.id : "",
            customer_products:
              nextActiveCustomer &&
              nextActiveCustomer.id === prev.activeCustomerId
                ? prev.customer_products
                : [],
            is_loading_products:
              nextActiveCustomer &&
              nextActiveCustomer.id === prev.activeCustomerId
                ? prev.is_loading_products
                : false,
            form: nextActiveCustomer
              ? this.getCustomerForm(nextActiveCustomer)
              : DEFAULT_FORM,
            page: {
              ...prev.page,
              totalPage: data.totalPage,
              totalItem: data.totalItem,
            },
            accordion: anyAccordion,
          }),
          () => {
            if (nextActiveCustomer) {
              this.dataCustomerActivityRender(nextActiveCustomer.id);
              this.dataCustomerProductsRender(nextActiveCustomer.id);
            }
          },
        );
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataListTagsRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/customer/tags"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState(
          (prev) => ({
            ...prev,
            data_tags: data.data,
          }),
          () => this.dataListRender(),
        );
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataAllRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/customer"}${this.getDateQueryString("?")}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          data_all: data.data,
          data_length: data.data.length,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataDashboardSummaryRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/customer/dashboard-summary"}${this.getDateQueryString("?")}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          dashboard_summary: data.data,
        }));
      })
      .catch(() => false);
  };

  dataCustomerActivityRender = (customerId) => {
    if (!customerId) return false;

    let tokenStr = localStorage.getItem("access_token");
    this.setState((prev) => ({
      ...prev,
      is_loading_activity: true,
    }));

    axios
      .get(
        `${END_POINT + "/customer/" + customerId + "/activity"}?limit=500${this.getDateQueryString("&")}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          customer_activity: data.data || [],
          is_loading_activity: false,
        }));
      })
      .catch(() => {
        this.setState((prev) => ({
          ...prev,
          customer_activity: [],
          is_loading_activity: false,
        }));
        return false;
      });
  };

  dataCustomerProductsRender = (customerId) => {
    if (!customerId) return false;

    let tokenStr = localStorage.getItem("access_token");
    this.setState((prev) => ({
      ...prev,
      is_loading_products: true,
    }));

    axios
      .get(
        `${END_POINT + "/customer/" + customerId + "/products"}?limit=100${this.getDateQueryString("&")}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        if (this.state.activeCustomerId !== customerId) return false;

        this.setState((prev) => ({
          ...prev,
          customer_products: data.data || [],
          is_loading_products: false,
        }));
      })
      .catch(() => {
        if (this.state.activeCustomerId !== customerId) return false;

        this.setState((prev) => ({
          ...prev,
          customer_products: [],
          is_loading_products: false,
        }));
        return false;
      });
  };

  onHandlerDelete = () => {
    if (!isD(ROLE_ALIAS)) return false;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .delete(`${END_POINT + "/customer"}`, {
        data: {
          arrayId: this.state.selectedItems,
        },
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["customer-delete"],
        });

        this.dataListTagsRender();
        this.dataAllRender();
        this.dataDashboardSummaryRender();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerUpdate = (e) => {
    if (!isU(ROLE_ALIAS)) return false;
    e.preventDefault();

    const {
      id,
      name,
      phone,
      email,
      address,
      point,
      armorial,
      used,
      debt,
      debt_more,
      debt_less,
      debt_limit,
      tags,
      dynamic_form,
    } = this.state.form;
    const normalizedName = ToTitleCaseName(name);

    if (!normalizedName || !id) {
      NotificatioErrController("Dữ liệu không hợp lệ");
      return;
    }

    const debtLessNumber =
      parseFloat(String(debt_less).replace(/\./g, "")) || 0;
    const debtMoreNumber =
      parseFloat(String(debt_more).replace(/\./g, "")) || 0;
    const nextDebt =
      (parseFloat(String(debt).replace(/\./g, "")) || 0) -
      debtLessNumber +
      debtMoreNumber;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT + "/customer"}`,
        {
          id,
          name: normalizedName,
          phone,
          email,
          address,
          point,
          armorial,
          used,
          debt: nextDebt.toString(),
          debt_limit: parseFloat(String(debt_limit).replace(/\D/g, "")) || 0,
          tags,
          dynamic_form,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["customer-update"],
        });

        if (debtMoreNumber > 0 || debtLessNumber > 0) {
          this.socket.emit("create logs", {
            user_id: localStorage.getItem("user_id"),
            message: LogsHelper["customer-debt-update"],
          });
          this.emitOrderRefresh();
        }

        this.dataListTagsRender();
        this.dataAllRender();
        this.dataDashboardSummaryRender();
        this.toggle("update");
        this.setState((prev) => ({
          ...prev,
          form: {
            ...prev.form,
            debt_less: "",
            debt_more: "",
          },
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onQuickDebtPayment = (customer, paymentAmount) => {
    if (!isU(ROLE_ALIAS)) {
      NotificatioErrController("Bạn không có quyền cập nhật khách hàng");
      return Promise.reject(new Error("Permission denied"));
    }

    if (!customer || !customer.id) {
      NotificatioErrController("Dữ liệu khách hàng không hợp lệ");
      return Promise.reject(new Error("Invalid customer"));
    }

    const currentDebt =
      parseFloat(String(customer.debt || "").replace(/\./g, "").replace(/,/g, "")) || 0;
    const normalizedPayment =
      parseFloat(String(paymentAmount || "").replace(/\./g, "").replace(/,/g, "")) || 0;

    if (normalizedPayment <= 0) {
      NotificatioErrController("Số tiền thanh toán phải lớn hơn 0");
      return Promise.reject(new Error("Invalid payment amount"));
    }

    if (normalizedPayment > currentDebt) {
      NotificatioErrController("Số tiền thanh toán không được lớn hơn dư nợ hiện tại");
      return Promise.reject(new Error("Payment amount is greater than debt"));
    }

    const nextDebt = Math.max(0, currentDebt - normalizedPayment);
    const form = this.getCustomerForm(customer);
    const normalizedName = ToTitleCaseName(form.name);

    if (!normalizedName) {
      NotificatioErrController("Tên khách hàng cần được thêm vào");
      return Promise.reject(new Error("Missing customer name"));
    }

    let tokenStr = localStorage.getItem("access_token");
    return axios
      .put(
        `${END_POINT + "/customer"}`,
        {
          id: form.id,
          name: normalizedName,
          phone: form.phone,
          email: form.email,
          address: form.address,
          point: form.point,
          armorial: form.armorial,
          used: form.used,
          debt: nextDebt.toString(),
          tags: form.tags,
          dynamic_form: form.dynamic_form,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thanh toán công nợ thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["customer-update"],
        });
        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["customer-debt-update"],
        });

        this.emitOrderRefresh();
        this.dataListTagsRender();
        this.dataAllRender();
        this.dataDashboardSummaryRender();
        this.dataCustomerActivityRender(customer.id);
        this.dataCustomerProductsRender(customer.id);
        this.setState((prev) => ({
          ...prev,
          form: {
            ...prev.form,
            debt: nextDebt.toString(),
            debt_less: "",
            debt_more: "",
          },
        }));

        return data;
      })
      .catch((err) => {
        NotificatioErrController(
          err.response?.data?.responseText || "Có lỗi xảy ra, vui lòng thử lại.",
        );
        return Promise.reject(err);
      });
  };

  onHandlerAdd = (e) => {
    if (!isC(ROLE_ALIAS)) return false;

    // console.log(this.state.form);
    e.preventDefault();
    const {
      name,
      phone,
      email,
      address,
      point,
      armorial,
      used,
      debt,
      debt_limit,
      tags,
      dynamic_form,
    } = this.state.form;
    const normalizedName = ToTitleCaseName(name);

    if (!normalizedName) {
      NotificatioErrController("Tên khách hàng cần được thêm vào");
      return;
    }
    if (!phone) {
      NotificatioErrController("Số điện thoại cần được thêm vào");
      return;
    }

    // console.log('data_all: ', this.state.data_all);

    // if (this.state.data_all.length > 20) {
    //     return NotificatioErrController(
    //         'Gói bạn đang dùng đã đạt giới hạn thêm khách hàng'
    //     );
    // }

    const initialDebtNumber =
      parseFloat(String(debt).replace(/\D/g, "")) || 0;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(
        `${END_POINT + "/customer"}`,
        {
          name: normalizedName,
          phone,
          email,
          address,
          point,
          armorial,
          used,
          debt: initialDebtNumber,
          debt_limit: parseFloat(String(debt_limit).replace(/\D/g, "")) || 0,
          tags,
          dynamic_form,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["customer-create"],
        });

        if (initialDebtNumber > 0) {
          this.emitOrderRefresh();
        }

        this.dataListTagsRender();
        this.dataAllRender();
        this.dataDashboardSummaryRender();
        // this.toggle('add');
        this.setState((prev) => ({
          ...prev,
          form: {
            ...prev.form,
            form: DEFAULT_FORM,
          },
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataAllProductsRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/product/all"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          data_products: data.data,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataAllOrdersRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/order/all"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          data_orders: data.data,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  // onHandlerAddExcel = () => {
  //     // if (!isC(ROLE_ALIAS)) return false;

  //     // // console.log(this.state.form);

  //     // const {
  //     //     name,
  //     //     phone,
  //     //     email,
  //     //     address,
  //     //     point,
  //     //     armorial,
  //     //     used,
  //     //     tags,
  //     //     dynamic_form,
  //     // } = this.state.form;

  //     // if (!name) {
  //     //     NotificatioErrController('Tên khách hàng cần được thêm vào');
  //     //     return;
  //     // }
  //     // if (!phone) {
  //     //     NotificatioErrController('Số điện thoại cần được thêm vào');
  //     //     return;
  //     // }

  //     let tokenStr = localStorage.getItem('access_token');
  //     axios
  //         .post(
  //             `${END_POINT + '/customer/create-from-excel'}`,
  //             {
  //                 name,
  //                 phone,
  //                 email,
  //                 address,
  //                 point,
  //                 armorial,
  //                 used,
  //                 tags,
  //                 dynamic_form,
  //             },
  //             {
  //                 headers: { Authorization: `Bearer ${tokenStr}` },
  //             }
  //         )
  //         .then((res) => res.data)
  //         .then((data) => {
  //             NotificatioSucController('Thành công');

  //             this.socket.emit('create logs', {
  //                 user_id: localStorage.getItem('user_id'),
  //                 message: LogsHelper['customer-create'],
  //             });

  //             this.dataListTagsRender();
  //             // this.toggle('add');
  //         })
  //         .catch((err) => {
  //             NotificatioErrController(err.response.data.responseText);
  //             return false;
  //         });
  // };
  /** Axios func helper */

  /** State func helper */
  toggle = (name) => {
    if (name === "add" && !isC(ROLE_ALIAS)) return false;
    if (name === "add-excel" && !isC(ROLE_ALIAS)) return false;
    if (name === "update" && !isU(ROLE_ALIAS)) return false;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        add_excel: name === "add" ? false : prev.show.add_excel,
        update: name === "add" ? false : prev.show.update,
        view: name === "add" ? false : prev.show.view,
        [name]: !prev.show[name],
      },
      selectedItems: name === "add" ? [] : prev.selectedItems,
      form: name === "add" ? DEFAULT_FORM : prev.form,
    }));
  };

  onChangeForm = (e, _name) => {
    if (e.target) {
      let {
        target: { name, value },
      } = e;

      if (["debt", "debt_more", "debt_less", "debt_limit"].includes(name)) {
        // Keep raw numeric digits in state, display formatting is handled in UI.
        value = String(value || "").replace(/\D/g, "");
      }

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [name]: value,
        },
      }));
    } else {
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [_name]: e,
        },
      }));
    }
  };
  onChangeDynamicForm = (e, _name) => {
    if (e.target) {
      let {
        target: { name, value },
      } = e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [name]: value,
          },
        },
      }));
    } else {
      let value = e.value ? e.value : e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [_name]: value,
          },
        },
      }));
    }
  };

  onSubmitForm = (type) => {
    if (type === "update") {
      this.onHandlerUpdate();
    } else if (type === "add") {
      this.onHandlerAdd();
    } else if (type === "add_excel") {
      // this.onHandlerAddExcel();
    }
  };

  onChangePage = (page) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          currentPage: page,
        },
      }),
      () => this.dataListRender(),
    );
  };

  onSearchKey = (e) => {
    if (!e) return false;

    if (e.target) {
      let {
        target: { value },
      } = e;
      let v = value;
      if (value === undefined) {
        v = e.target.firstElementChild.value; // parent to child

        // value = v.toLowerCase();
        // this.setState(
        //     (prev) => ({
        //         ...prev,
        //         page: {
        //             ...prev.page,
        //             search: value,
        //         },
        //     }),
        //     () => this.dataListRender()
        // );
      }
      // else {
      //     value = value.toLowerCase();
      //     this.setState(
      //         (prev) => ({
      //             ...prev,
      //             page: {
      //                 ...prev.page,
      //                 search: value,
      //             },
      //         }),
      //         () => this.dataListRender()
      //     );
      // }
    }

    if (e.key === "Enter") {
      let value = e.target.value.toLowerCase();
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: value,
          },
        }),
        () => this.dataListRender(),
      );
    }
  };

  onSearchChange = (value) => {
    this.setState(
      (prev) => ({
        ...prev,
        filter: null,
        page: {
          ...prev.page,
          currentPage: 1,
          search: String(value || "").toLowerCase(),
        },
      }),
      () => this.dataListRender(),
    );
  };

  onChangePageSize = (size) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          selectedPageSize: size,
          currentPage: 1,
        },
      }),
      () => this.dataListRender(),
    );
  };

  onClickedItem = (item, callback, args) => {
    this.selectActiveCustomer(item);
    if (callback && args) callback(args[0], args[1], args[2]);
  };

  onClickedUpdate = (item) => {
    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        update: true,
      },
      activeCustomerId: item.id,
      form: this.getCustomerForm(item),
    }));
    this.dataCustomerActivityRender(item.id);
    this.dataCustomerProductsRender(item.id);
  };

  onClickedDelete = (item) => {
    let selectedSet = SetItemsSelected(
      item.id,
      this.state.selectedItems,
      "require",
    );
    if (window.confirm("Bạn chắc chắn muốn xoá khách hàng này?")) {
      this.setState(
        (prev) => ({
          ...prev,
          selectedItems: selectedSet,
        }),
        () => this.onHandlerDelete(),
      );
    }
  };

  onClickedCheckbox = (id, event) => {
    // Toggle multi-select
    let selectedSet = SetItemsSelected(id, this.state.selectedItems);

    this.setState((prev) => ({
      ...prev,
      selectedItems: selectedSet,
    }));
  };

  handleChangeSelectAll = (isToggle) => {
    const { selectedItems, data, data_all, displayMode } = this.state;
    const targetData = displayMode === "list" ? data_all : data;

    if (selectedItems.length >= targetData.length) {
      if (isToggle) {
        this.setState({ selectedItems: [] });
      }
    } else {
      this.setState({ selectedItems: targetData.map((x) => x.id) });
    }
    document.activeElement.blur();
    return false;
  };

  toggleAccordion = (tab) => {
    const prevState = this.state.accordion;
    const state = prevState.map((x, index) => (tab === index ? !x : false));
    this.setState({
      accordion: state,
    });
  };

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  applyFilteredCustomers = (filteredCustomers, filter) => {
    const nextActiveCustomer =
      filteredCustomers.find((item) => item.id === this.state.activeCustomerId) ||
      filteredCustomers[0] ||
      null;

    this.setState(
      (prev) => ({
        ...prev,
        data: filteredCustomers,
        filter,
        activeCustomerId: nextActiveCustomer ? nextActiveCustomer.id : "",
        customer_activity:
          nextActiveCustomer && nextActiveCustomer.id === prev.activeCustomerId
            ? prev.customer_activity
            : [],
        customer_products:
          nextActiveCustomer && nextActiveCustomer.id === prev.activeCustomerId
            ? prev.customer_products
            : [],
        is_loading_products:
          nextActiveCustomer && nextActiveCustomer.id === prev.activeCustomerId
            ? prev.is_loading_products
            : false,
        form: nextActiveCustomer
          ? this.getCustomerForm(nextActiveCustomer)
          : DEFAULT_FORM,
        page: {
          ...prev.page,
          currentPage: 1,
          totalItem: filteredCustomers.length,
          totalPage: 1,
        },
      }),
      () => {
        if (nextActiveCustomer) {
          this.dataCustomerActivityRender(nextActiveCustomer.id);
          this.dataCustomerProductsRender(nextActiveCustomer.id);
        }
      },
    );
  };

  filterData = (key, value) => {
    const { data_all, data_tags } = this.state;

    if (key === "" && value === "") {
      this.setState(
        (prev) => ({
          ...prev,
          filter: null,
          page: {
            ...prev.page,
            currentPage: 1,
          },
        }),
        () => this.dataListRender(),
      );
      return;
    }

    let filteredCustomers = data_all;

    if (key === "email" && value === "none-empty") {
      filteredCustomers = data_all.filter(
        (item) => item[key] !== "" && item[key] !== null,
      );
    } else if (key === "email" && value === "") {
      filteredCustomers = data_all.filter(
        (item) => item[key] === "" || item[key] === null,
      );
    } else if (key === "tags") {
      const filteredCustomerIds = data_tags
        .filter((tag) => tag.label === value)
        .map((tag) => tag.customer_id);

      filteredCustomers = data_all.filter((customer) =>
        filteredCustomerIds.includes(customer.id),
      );
    } else if (key === "debt" && value === "have_debt") {
      filteredCustomers = data_all.filter((item) => Number(item.debt) !== 0);
    } else if (key === "debt" && value === "") {
      filteredCustomers = data_all.filter((item) => Number(item.debt) === 0);
    } else if (key === "segment" && value === "vip") {
      filteredCustomers = data_all.filter((item) => {
        const rank = String(item.armorial || "").toLowerCase();
        const tags = (item.tags || []).map((tag) =>
          String(tag.label || "").toLowerCase(),
        );
        return rank.includes("vip") || tags.some((tag) => tag.includes("vip"));
      });
    } else if (key === "segment" && value === "new") {
      const now = new Date();
      filteredCustomers = data_all.filter((item) => {
        const createdAt = new Date(item.createdAt);
        return (
          createdAt.getFullYear() === now.getFullYear() &&
          createdAt.getMonth() === now.getMonth()
        );
      });
    } else if (key === "segment" && value === "sleeping") {
      const maxInactiveMs = 60 * 24 * 60 * 60 * 1000;
      filteredCustomers = data_all.filter((item) => {
        if (!item.last_order_date) return true;
        const lastOrderDate = new Date(item.last_order_date);
        if (Number.isNaN(lastOrderDate.getTime())) return true;
        return Date.now() - lastOrderDate.getTime() > maxInactiveMs;
      });
    } else {
      filteredCustomers = data_all.filter((item) => item[key] === value);
    }

    this.applyFilteredCustomers(filteredCustomers, { column: key, value });
  };

  // ChatGPT
  // filterData = (key, value) => {
  //     const { data_all } = this.state;
  //     let filteredData = data_all;

  //     if (key === 'email') {
  //       if (value === 'none-empty') {
  //         filteredData = data_all.filter(item => item[key] !== '' && item[key] !== null);
  //       } else if (value === '') {
  //         filteredData = data_all.filter(item => item[key] === '' || item[key] === null);
  //       }
  //     } else if (key && value) {
  //       filteredData = data_all.filter(item => item[key] === value);
  //     }

  //     this.setState(({ filter }) => ({
  //       data: filteredData,
  //       filter: key && value ? { column: key, value } : null,
  //     }));
  //   };

  handleDataUpdate = (changedItems) => {
    this.setState((prevState) => {
      const newChanged = { ...prevState.changedCustomers };
      const updatedAllData = [...prevState.data_all];
      const updatedData = [...prevState.data];

      changedItems.forEach((changedItem) => {
        if (changedItem.id) {
          newChanged[changedItem.id] = changedItem;
        }
        // Sync data_all
        const idxAll = updatedAllData.findIndex((c) => c.id === changedItem.id);
        if (idxAll !== -1) {
          updatedAllData[idxAll] = changedItem;
        }
        // Sync data (card view)
        const idxPage = updatedData.findIndex((c) => c.id === changedItem.id);
        if (idxPage !== -1) {
          updatedData[idxPage] = changedItem;
        }
      });

      return {
        changedCustomers: newChanged,
        data_all: updatedAllData,
        data: updatedData,
      };
    });
  };

  handleSaveChanges = async () => {
    const { changedCustomers } = this.state;
    const dataToSend = Object.values(changedCustomers);

    if (dataToSend.length === 0) return;

    try {
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.put(
        `${END_POINT}/customer/bulk-update`,
        dataToSend,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );

      NotificatioSucController(
        response.data.responseText || "Cập nhật thành công!",
      );

      this.socket.emit("create logs", {
        user_id: localStorage.getItem("user_id"),
        message: LogsHelper["customer-update"],
      });
      this.emitOrderRefresh();

      this.setState({ changedCustomers: {} });
      this.dataAllRender();
      this.dataListRender();
      this.dataDashboardSummaryRender();
    } catch (err) {
      NotificatioErrController(
        err.response?.data?.responseText || "Có lỗi xảy ra, vui lòng thử lại.",
      );
    }
  };

  changeDisplayMode = (mode) => {
    this.setState((prev) => ({
      ...prev,
      displayMode: mode,
      show: {
        ...prev.show,
        view: false,
      },
    }));
    // Reload cả 2 data source khi chuyển chế độ
    this.dataAllRender();
    this.dataListRender();
    return false;
  };

  render() {
    const {
      page,
      selectedItems,
      data,
      data_all,
      data_tags,
      is_loading_data,
      show,
      form,
      filter,
      dashboard_summary,
      customer_activity,
      customer_products,
      is_loading_activity,
      is_loading_products,
      activeCustomerId,
      displayMode,
      changedCustomers,

      // Dynamic Form
      data_dynamic_form,
    } = this.state;

    const dataToSend = Object.values(changedCustomers);

    if (!isR(ROLE_ALIAS))
      return (
        <Card className="text-muted mh-40vh h-100">
          <CardBody className="d-flex justify-content-center align-items-center">
            Bạn không có quyền sử dụng tính năng này!
          </CardBody>
        </Card>
      );

    return is_loading_data ? (
      <div className="loading" />
    ) : (
      <div
        // className={classnames(
        //     'disable-text-selection',
        //     displayMode === 'thumblist' ? 'app-row' : ''
        // )}
        className="customer-modern-shell disable-text-selection"
      >
        <AddCustomer
          title={<IntlMessages id="customer.add-new-modal-title" />}
          isOpen={show.add}
          toggle={() => {
            this.toggle("add");
          }}
          data_dynamic_form={data_dynamic_form}
          data_tags={data_tags}
          values={form}
          setting={show}
          onChange={this.onChangeForm}
          onChangeDynamicForm={this.onChangeDynamicForm}
          onSubmit={this.onHandlerAdd}
        >
          {/* <ContentForm
                    /> */}
        </AddCustomer>
        <Add
          title={<IntlMessages id="customer.add-new-modal-title" />}
          isOpen={show.add_excel}
          toggle={() => {
            this.toggle("add_excel");
          }}
          onSubmit={this.onHandlerAddExcel}
        >
          <ContentFormAddExcel
          // data_dynamic_form={data_dynamic_form}
          // data_tags={data_tags}
          // values={form}
          // setting={show}
          // onChange={this.onChangeForm}
          // onChangeDynamicForm={this.onChangeDynamicForm}
          />
        </Add>
        <UpdateCustomer
          title={<IntlMessages id="customer.title" />}
          onSubmit={this.onHandlerUpdate}
          isOpen={show.update}
          toggle={() => {
            this.toggle("update");
          }}
          data_dynamic_form={data_dynamic_form}
          data_tags={data_tags}
          values={form}
          setting={show}
          onChange={this.onChangeForm}
          onChangeDynamicForm={this.onChangeDynamicForm}
        />
        <CustomerModernDashboard
          page={page}
          data={data}
          dataAll={data_all}
          dataTags={data_tags}
          summary={dashboard_summary}
          activity={customer_activity}
          products={customer_products}
          activityLoading={is_loading_activity}
          productLoading={is_loading_products}
          selectedItems={selectedItems}
          activeCustomerId={activeCustomerId}
          filter={filter}
          dateFilters={this.state.filters}
          onDateRangeChange={this.onDateRangeChange}
          onSetDatePreset={this.setDatePreset}
          onClearDateFilter={this.onClearDateFilter}
          displayMode={displayMode}
          changedCount={dataToSend.length}
          canCreate={isC(ROLE_ALIAS)}
          canUpdate={isU(ROLE_ALIAS)}
          canDelete={isD(ROLE_ALIAS)}
          onAdd={() => {
            this.toggle("add");
            this.toggleAccordion();
          }}
          onSearchChange={this.onSearchChange}
          onFilterData={(key, value) => this.filterData(key, value)}
          onChangePage={(i) => this.onChangePage(i)}
          onChangePageSize={this.onChangePageSize}
          onChangeDisplayMode={this.changeDisplayMode}
          onSelectCustomer={this.onClickedItem}
          onToggleCustomer={this.onClickedCheckbox}
          onSelectAll={this.handleChangeSelectAll}
          onUpdateData={this.handleDataUpdate}
          onUpdateCustomer={this.onClickedUpdate}
          onDeleteCustomer={this.onClickedDelete}
          onPayDebt={this.onQuickDebtPayment}
          onBulkDelete={() => {
            if (window.confirm("Bạn có chắc chắn muốn xóa bản ghi này?")) {
              this.onHandlerDelete();
            }
          }}
          onSaveChanges={this.handleSaveChanges}
          onRefreshActivity={() => this.dataCustomerActivityRender(activeCustomerId)}
          onRefreshProducts={() => this.dataCustomerProductsRender(activeCustomerId)}
        />
        <FooterPage>
          <FooterCustomer />
        </FooterPage>
      </div>
    );
  }
}

const mapStateToProps = ({ searchInput }) => {
  const { keyword: searchKeyword } = searchInput;
  return { searchKeyword };
};

export default connect(mapStateToProps, {
  setSearchContext,
})(ContentComponent);
